<template>
  <div style="height:100vh;width:100%;" v-loading="isLoading">
    <div style="height:100vh;width:100%;" v-if="readerType != 'xiaozhixuexi'">
      <!-- 小智解读 -->
      <template v-if="readerType == 'xiaozhijiedu'">
        <i-reader
          logo="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyAAAAMgCAMAAADsrvZaAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAk1BMVEX////09/vS4O2wyeCl wtt4pMptnMVLhbiPs9O70eT78tT57cb03I7z2IDvy1bqvSvpuR346bhWjbxilMHd6PL89uP35aro 8PbtxkjswjmDq87x03L14Jyau9fH2en++/Hwz2Tr3aXCrESGmX7VszCan2tViK7ftiekomFfjKWu pldpj5tzkpHLrzqQnHS4qU3///8jLtBOAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAHdElN RQfmCgkGHQ2+IWkHAAAbfElEQVR42u3diVrjupaGYRISZkIqDGGqCmePvU+f7r7/u2uGKgQogy1L +rWk770CEvw9K7ZXnL09AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAMBGo/H+ZDo9OHw3nR5NjsfqPwsJnJyenc9mF/NfLmaz87NvJ+o/ q1zjyXRxuMHl0f6V+u9DNNffzmfzTWbnN9fqP7A4y/3p4S6Lo+OR+u/EcKfnt/Nd7s6/qf/Mgiz3 D3bW8dM9jdh2+nCxs46fn7geaOTV8e7Z8ckRZyRWXZ/ddazj5xw5a/6z1miy6JfHi4Nj9Z+NAKcP vep483Cq/rOVlkf963g7ZycRa05nAXm8nrM3m8hoEpgHiZgTnEfDiYR8uPqUCOciVlyHfLj69EGr vXOR8eWwPF7cL9WvAl08dr1wtdnFmfpF5DX6PjyPZ4t99QvBTie773p0cdvSLfYY4+PNlNsihTuL kseLdobIkJNzb4j8UL8abLEacnL+1ayNM5FRzxuDu0zULwgbnQ4/+/joooXLWVfRPl7xMat0N1Hz ePGofknJHQ+8uLvOAVezijT04u46D+oXldhx/DyeLViFL8/qKUEfzyciK/ULSynm6TmFFG0V5+qu 77biQkJXryjEnGR91FxIuj4opDAJ+6i3kP2EfVBIUZL2UWshac7PKaRET0n7eD5TV7/ABMaJ+zg8 vOR+SCFSXN/9rL6rvVcJ7n98daB+kXgV//6gr7Y7hqPOj2UY4kj9MvHsNEMf83llWyf3Ofo4PORr hnqruPtXm1xUtbmY9gKWw4m6Xsz93W1qOlHPcQLyhtMQtcdMfVT1/ZAsJyBvWH7XOsnWx3xezXcM U21grcWHLKm0dwg/u1W/2EiW2T5gvZiqX27T8n3AelHJh6zI3yDchQc56GS6gvVLHVey0t9C/2zB DXWZ9LfQP6vihnr0r9juwnm6Ss4z9DcV3C5MvaO4Bt/AFcl1C8Sp4GZI9gHCxolKnh2TykaIYIAw QkTyD5AKRohggBwefle/6iblPwOpYIT8UPTBhSyJ3Jew3hi/kJX5Hsgv3AvJbyXpYz43fS9kqenj 8FL9whuU9ya6Y/p2epxfOQjARlZ2/X6fM5479QsfQnKK/oIrvblpTtFfGP61aM0p+ouF+qU3R3OK /sLwaXrKJ8XtwM+GZJZ3TfGjC/VLDyf7hMVnrNx0n7AMf8a60vXBdazMzoWBnKtffKis3yT8iutY WeX8JuFXZq9jie4SvuFeYU6qu4RvrN4rVPZxeK9+9U35Jg3kRv3yw+T+KuFnXOjNKd6PPYcwehKS 62lxG7DznpFi090xuvMuvAvygjshGUn7mM/VLz+M9Bydr6bndC0OxOYj5LR9cJaekeLLth+ZvFU4 EgfCE+Ty0Z6jG115117EeqZ+AxqiDsTkZSzdKi+B5Ka9iGX0MpZ00eQFyybZEEgAeSBj9TvQDuUm 1guTG+8E0g5xHzZvhIhvgxBIRuo+5uo3IIQ8EH7RMxt1H3P1GxBCHgi30rNR9zFXvwEhCKQd6j7m 6jcgBIG0Q93HXP0GhJAHwjlINuo+5uo3IIQ8EK5iZaPuY65+A0JwH6Qd6j7m6jcgBIG0gzvpAeSB sIuVDbtYAdjmbQeBBOD7IO3g+yAB+EZhO9SBmPxGId9JbwffSQ/BU02awVNNQvBcrHbofh3klfrl h+HJiu3gyYoBlD8PwrN58+LZvCGkgXCOnhNPdw/B74M0g98HCSE9CWHRJCvlNtat+sWH4jcK28Fv FIbgV26bwa/chviuC4S7IJndyfowuev+RvcZi4u8uek+Yz2oX/oAss9YfMLKTfcZy+4nLOFnLK5h Zaf6jGX2V9JfLEV9cA0rv0dRIDZX3X8R3SvkiT/5qe4VWr1L+EbzvdvFSP26W/Qg6cPyKfoLyWk6 XwVR0Hwp5FT9sgc6VgTCpruEYufd6Kb7B4IRwjVeDcUXb60PEMUIWTBARPKPEPsDRDBCOANRyX8W Yn+A5H8+FpewdHJfyLJ+CevNfd5AuAeis8r78IYL2/dAflkucvbB8+KU8t5Of1S/3EiyfrOQLSyp nOfpZr9J6DnI1wdn6FrXGT9k2Xxc3Dr5PmQdqF9q8/J9yLK9pfhZrpsh3ALRy/Uhq4ZbIE6mx5By BUsv05Wsi5X6hUY1ynIa8l39MrGX67uFNdwi/Ogqw2kIV3jLcJOhj1qu8Drpb6gfcAu9EOlvqNdx C/2z1CfqC+6AFCN1IU/qF5hE2kLooyCrtE8iva3rBP1dyh+Gpo+iJC2k1j5SPgWIPgqTsJB6+0j3 KYs+ipOskJr7SFUIfZQozZn6U9V97O39SHA/hOu7ZUpRSI3Xdz+7iv4V3Hv6KFT8O4ZWf2ytj1Hk py2y4F6uk7h7WRe17ZdsEPNy72KsfjXYYhVzt3dW+emHE+9jFh+vSvcYbYjU9P2PXUZx7ogs+B2p 8p3EGSK39Xx/sJNxhP33I8aHCRGGyEV927s77Q+84HvA2YcVq6EXfB+aOfv4aDQZkMglXx605HrI 56xZY5+unOBEyMOc09BEZo1c211vNAm4oDUlD4uuQz5oPTQ7Pd4d93s06eKIxSurVo/9funz7qyO Z4sOtdzvfEnr/pgrV6adnHdt5ILh8cFyf/ccuTyijhqcnO/ehL89pw7PeHK/8YTk4OiYT1b1WH07 23zOPjv/1uRV3U5G4+PJ/dStMy6m0++TH7RRo+vTs7PZzE2T29ns7OyUsw4AAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAEG42PJ5NpfY7Ub+xg57P6nJ89nl6r39jORj8m08Vhrcbqt3eg03mtLmZn31bq t3en5f5UfQinNVW/wwPN1MdxWrPHkifJcv9AffymZ3uE1DtA3t3eFDpHxkfqYzcL2yPkTn345nDx UOAYGVf+0cqxPEJu1MduLqUl0k4etkdIEwOkvESWDeVxaHmEPKqP2qzOSjkXmaiP2MzMjpDVhfqY zevuVP2Ov7hq4MrVF1ZHyJn6iM3uXD9E9tVHq4DREdLaAHlxe6J9z0f36oNVwuYIeVAfrQoX35Rv eYMfr17dq4/1ENfqY1XkUfeWX9W7crXDUn20B2hygLx4UL3jx832cWhwqfdEfZw2V8ix+ihVsjdC Kt9SLK+QpvuwN0Ia2FIsq5Cx+hAVszZCWh4gikLaPT//ydgIaWZLcZObvO/3qPU+rI2QhrYUN8i7 dtLo/Y+PTI2Q5gfIfH6Rc+vku/roLIGhEbJigMzns3zv9w/1sVkEQyOkvS3Fdc5yvd2cgLwxM0Ja 3FJcJ9fiYpsLij4zI4QB8ibThyw+YP1iZIRcM0B+ynKtd3SpPi6LMVEf+t00u6XoyXIlq7Uv2G6x GKmP/S5aXXNfJ8N5+pIzdMfECHlSH5UFyTBC2ng6XEcWRkjbW4pfJR8hS/UxWRYDI6TxLcUvko8Q zkA+KX+EMEA+S3whi3uEXxQ/Qm7VR2RhbtO+3W1/S2qN0kcIW4pfpb2dzhbvV4WPELYUvzpP+XZf qQ/H8pQ9Qtp6GG8ndynfb9bcfSWPELYU10j5GYstE1/JI4QtxTUS3gpZqg/GIu2rM9iIAbJOwutY LT6oerdLdQcbnauPxTKlu1fIF0HWOlaHsAFbiuule3wDdwnXKnWEsOa+XrKTEC7yblDmCGn4Ybzb PaV6x7mNvkGZI4QtxQ2SnaWzqLhJiSOELcWNUr3lbf2WbR8ljhAGyEapLmNxm3Cj8kbIN/VRWLBU l7HUR2HByhshbCluliiQkfooLFlpI4Q19y0S/a5n678IslVhI4SH8W6T6EYIgWxT1ghhS3EbAhE4 UDfxEVuKWxGIwlhdxQcMkK0IRGGqrsLhYbzbEYhEOSOELcXtCESimBHCmvsOBKJRygh5Uh+ApSMQ jUJGCFuKuxCISBkjhC3FXQhEpIgRwgDZiUBUShghPIx3JwJRKWCEsKW4G4HI6EcIW4q7EYiMfITw MN4OCETnStsHW4pdEIjOkTYQthS7IBChpbIPBkgnBCIkHSE8jLcTAlESjhC2FLshECXhCGHNvRsC kZKNEB7G2xGBSMlGCFuKHRGIlmiEsKXYFYFoiUYIA6QrAhGTjBAextsZgYhJRghbip0RiJpghLDm 3h2BqH3P3gcP4+2BQNQWo9yBsKXYA4HITTL3wZZiHwQil3uEMED6IBC9vCOEh/H2QiB6eUcIW4q9 EEgBco4Q1tz7IZAC5BwhT+ojzhgCKUG+EcKWYk8EUoJ8I4QtxZ4IpAi5RggDpC8CKUKuEcLDePsi kDLkGSFsKfZGIGW4zBIIW4q9EUghjjP0wcN4+yOQQmQYIWwpBiCQUqQfIWwpBiCQUiQfIQyQEARS jNQjhIfxhiCQYiQeIWwpBiGQcqQdIay5ByGQciQdITyMNwyBFCTlCGFLMQyBFCThCGFLMRCBlCTd CGGABCKQkiQbITyMNxSBFOVHokDYUgxFIEWZpvl3sOYejEDKMk7x3+BhvOEIpCxJRghbiuEIpDAJ RghbigMQSGESjBAGyAAEUproI4SH8Q5BIKWJPkLYUhyCQIoTeYSw5j4IgRQn8gh5Uh9ithFIeaKO ELYUhyGQ8kQdIWwpDkMgBYo4QhggAxFIgY7i/SN4GO9ABFKiZaz/A1uKQxFIiaKNELYUhyKQIkUa IQyQwQikSHFGCFuKwxFImaKMELYUhyOQMsUYIQyQCAikUBFGCA/jjYBACjV8hLClGAOBlGrwCGHN PQYCKdXQEcIAiYJAijVwhLClGAWBFGvYCGFLMQ4CKdZiNOQ/wACJg0DKNRnwD+BhvJEQSLmGjBC2 FCMhkIKFjxC2FGMhkIKFjxAGSCwEUrLQEcKWYjQEUrLAEcKWYjwEUrSwEcIAiYdAihY0QngYb0QE UraQEcKWYkQEUraAEcKWYkwEUrj+I4QBEhOBFG7R961nSzEqAindcc+3ni3FqAikdJf93nkGSFwE Urx+I4SH8cZFIMXrNULYUoyMQMrXZ4SwpRgZgZSvxwhhgMRGIAZ0HiFsKUZHIAZ0HiFsKUZHIBZ0 HCEMkPgIxIKOI4SH8cZHICZ0GiFsKSZAICZ0GiFsKSZAIDZ0GCEMkBQIxIbp7vecLcUUCMSI8a63 nC3FJAjEiJ0jhAGSBIFYsWOE8DDeNAjEih0jhC3FNAjEjK0jhC3FRAjEjK0jhAGSCIHYsWWEsKWY CoHYsXmEsKWYDIEYsnGEMECSIRBDNo0QHsabDoFYsmGEsKWYDoFYcr9+gKgPopoRiClLBkhmBGLK 0Zr3mi3FlAjEljUjhC3FlAjEFn+EMECSIhBjvBHCw3iTIhBjvo4QthTTIhBrvowQthTTIhBrPo8Q BkhiBGLOxxHClmJqBGLOxxHClmJqBGKPGyEMkOQIxB43QngYb3IEYtDo57vMlmJ6BGLQ5Oe7zJZi egRi0GLEAMmFQCx6GyFsKWZAIBa9jhC2FHMgEJMmDJBMCMSk5xHCw3izIBCbJmwp5kEgNi3+pT5y GkEgRv2mPnIaQSBG/a4+chpBIFb9oT502kAgVjFCsiAQsxghORCIWX+qj50mEIhZf/2tPnhaQCB2 MUIyIBC7GCEZEIhhjJD0CMQwRkh6BGIZIyQ5ArGMEZIcgZjGCEmNQExjhKRGILYxQhIjENsYIYkR iHH/pT6CKkcgxv2jPoIqRyDW/Vt9CNWNQKxjhCRFIOYxQlIiEPMYISkRiH2MkIQI5N1C/QeEYoQk RCDvJuo/IBgjJB0CeTeeqv+CUIyQdAjk3Xip/guC2RghJh+3TSDvxntH6j8hlI0RcqP+A0IQyLvx 3tLsebqFEfJg8iexCOTdeG/P7Hn6f6uPow6uCcR8ICOzI6T8X0N4sPmjigTy7jmQvX31HxHqP+oD aadrAqkgkL1L9V8RqvQR8mD0Z3kJ5N1rIMfqvyJU4SPk4ppAqghkz+zdwrJHyMtxRiA1BGLxL39V 9Ai5WBFIJYEwQpIdZgRSRSBL9d8RquAR8jpACKSOQOwunJQ7Qt6OMgKpIxCzCyfFjpC3AUIglQRi d+Gk1BHy8yAjkEoCMbtwUugI+TlACKSWQOwunPyP+nDaeowRSC2BmF04+V19OK1z9+tdJZBqAjG7 cPKH+nha44ZAqgvE7N3CAkfI+wAhkIoCsfj3vypvhLwPEAIxfoB9DIQREosbIARSUyBL9V8TqrQR 4gYIgdQUiNmFk8JGyIcBQiBVBWJ24aSsEfJhgBBIVYGYXTgpaoR8HCAEUlcgZhdOShohpwRSbSBm F04KGiGzT28ogdQViNmFk3JGyKcBQiC1BWJ14eR/1QfVL58HCIHUFojVu4V//a0+qn76PEAIpLpA LL6KF3+qj6o3XwYIgRg/tPxAGCGDfBkgBFJfIEv13xSoiBHydYAQSH2BWF04KWKEfB0gBFJhIFYX TgoYId4AIZAKA7G6cFLACLkmkBYCsbpwIh8hD/57SSAVBmJ14UQ+QvwBQiBVBmJ14UQ8QtYMEAKp MxCjCyfiEbJmgBBInYFYvVsoHSHrBgiBVBqIxdfy7B/lYbVugBCI8YNqUyBWR8i/dUfV2gFCILUG slT/ZWGEI2TtACGQWgOxunAiGyEbDioCqTUQowsnqhHy6+cOCKSVQKwunIhGyKZjikCqDcTowolm hGwaIARSbyBWF04kI2TjIUUg9QZidOFEMUI2DhACqTkQowsnghGy+YgikIoDMXq3MP8I2TxACKTq QCy+okPBCNlyQBGI7cNpeyCMkE7uNg8QAqk7kKX67wvzf3mPp5st7yCBVB2I0YWT/2Q9nO62vYEE UncgRhdOfst5OG0bIARSeSBGF05yjpCtA4RAag/E6MJJxhGydYAQSO2BGF04yTdCtg8QAqk+EKML J9lGyPYBQiD1B2Jz4STXCNkxQAik/kCM3i3MNEJ2DBACaSAQi68r1wiZ7XrzCMT2gdQlEEbIZqe7 3jsCaSCQpfqvDJJjhOwcIATSQiBGF04yjJCdA4RAmgjE5sLJ78kPpN0DhECaCMTowskfqQ+k3QOE QNoIxObCSeoR0mGAEEgbgRhdOEk8QjoMEAJpJBCbCydpR0iXAUIgrQRic+Ek6Qg5IRACcUzeLUw5 Qh46vW0E0kogFl9d0hFy3eltIxDbh1D3QBghn3UbIATSTiBL9d8aJNkI6TZACKSdQGwunKQaIR0H CIE0FIjNhZNEI6TjACGQhgKxuXCSZoR0HSAE0lIgJhdO/vo7xSHUdYAQSEuB2Fw4+TPBEXTe+S0j kJYCMblwkmCEbPm5AwJpOhCTCyfxR0iPA4hAmgrE5N3C6COkxwAhkMYCsfgao4+QPscPgdg+ePoG wgjpN0AIpLVAluq/OETcEdLr8CGQxgIxuXASdYT0GiAE0lwgJhdOYo6QfkcPgbQWiMmFk4gjpN8A IZD2AjG5cBJvhDz2e7cIpLlATC6cRBshu37ugEAIxOTCyb8jHTu7fu6AQAjE5MLJP3EOnb4DhEBa DMTk3cI4I6TvACGQJgOx+EqjjJDeA4RAjB82YYE0O0J6DxACaTOQpfrvDhBhhHR62CiBEIjNu4XD R0inh40SCIE8O1D/5f0NHiEhxw2BNBrIlcH76QNHSMAHLAJpNpC9H+o/vb9hI+Su3xIWgTQeiMXb hUNGyEXACQiBtByIwUIGjJDAPgik4UAMFhI8QkL7IJCWA9n7Ye1M/T+BR8xt0PkHgbQeyN7S2i31 34IOmO4PUiQQAvls39YQCRkht11+zZZACGS9ka2nOPQeIXf9968IhEA+Wn43NEV6jpDbYXkQCIG8 +nFkppEeI+TuPPTaFYEQyFdX+9+nFk7ZO42Qu9ns7Fvn3wAhEAJBIAJxCAQeAnEIBB4CcQgEHgJx CAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgE HgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4C cQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEI BB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQe AnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJx CAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgE HgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4C cQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEI BB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQe AnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJx CAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgEHgJxCAQeAnEIBB4CcQgE HgJxCASea/XBTiCDXKkPoOqpD3YCGUR9+NRPfbATyBAL9eFTv5n6aCeQAabqw6d+T+qjnUAG+K4+ fOp3pj7aCWSAH+rDp34Wr/MSyC8j9eHTAPXRTiDhDtQHTwue1Ic7gQTbVx88LbhRH+4EEmypPnha sFIf7gQSiou8WTyoj3cCCXSsPnTaYO86FoG8ulQfOa0wdzOdQF4xQDIxN0II5AUDJBtrI4RAXvBV kGysjRACeXavPmpacq4+5AmkrwVbJhmt7tTHPIH0xJpiVifqY55A+mHPPbNH9UFPIH1wApKdpfvp zQdywAlIfoau9bYeCH0orG7Vxz2B0EfJVmZmSNuB3NOHipXzkKYDmaiPkpYZuZbVcCALFkykTkzc MWw3kCM+XomtLGydtBrIAeOjACfln6u3Gcgl3/8oxGnpibQYyD3ToyCnZV/Pai6Q+2POPQqzunm6 UHdAIM+m9xNmR6FOHx/K/LCVKJDRuDTMDQNWp8W5Vr8nAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABDq/wF1PGd8v4azVQAAACV0RVh0 ZGF0ZTpjcmVhdGUAMjAyMi0xMC0wOVQwNjoyOToxMyswMDowMGMOzT8AAAAldEVYdGRhdGU6bW9k aWZ5ADIwMjItMTAtMDlUMDY6Mjk6MTMrMDA6MDASU3WDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ bWFnZVJlYWR5ccllPAAAAABJRU5ErkJggg=="
          label="小智解读" hideInspector :domain="serverUrl" :satoken="requestHeader.satoken" hideNotice hideMessageBtn hideMoreBtn>
          <reader-bar-sample type=".pdf,.docx,.xlsx,.pptx" slot="bar-middle"></reader-bar-sample>
          <reader-bar slot="bar-menu" >
            <reader-bar-openfile class="bar-option" model="hidden" title="点击打开需要解读的文件"
              type=".pdf,.docx,.txt"></reader-bar-openfile>
            <reader-bar-openfile-i :satoken="requestHeader.satoken" openDialog slot="desc" title="选择要解读的文件"
              type=".pdf,.docx,.txt"></reader-bar-openfile-i>
            <reader-bar-application class="bar-option" title="选择模型后开启解读功能" label="解读" menuName="解读" icon="auto_fix_high"
              pbc="file_no_arg_recogn" withModel disabled></reader-bar-application>
          </reader-bar>
          <div slot="bar-btn" style="display: flex">
            <el-button type="text" @click="gotoDiyPage" title="定制" style="margin-left:3px;"
              :disabled="!modelSuccess">
              <svg style="width:17px; height:17px;" t="1695086422547" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="8567" width="200" height="200">
                <path
                  d="M833.3 515.33l159.09-159.1c43-43 43-111.8 0-150.49L824.7 38.04c-38.7-38.7-111.8-38.7-150.5 0L515.11 197.13 356.02 38.04c-38.7-38.7-111.79-38.7-150.49 0l-167.7 167.7c-43 43-43 111.8 0 150.49l159.09 159.1-68.8 64.5c-12.9 12.9-21.5 25.8-25.8 43L7.73 885.11c-12.9 34.4-4.3 68.8 12.9 94.6 21.5 25.8 51.59 43 86 43 12.9 0 21.5 0 34.4-4.3l262.29-94.6c17.2-4.3 30.1-12.9 43-25.8l64.5-64.5L669.91 992.6c21.5 21.5 47.3 30.1 77.4 30.1 30.1 0 55.9-12.9 77.4-30.1L992.4 824.9c43-43 43-111.79 0-150.49L833.3 515.33zM761.61 89.64c4.3 0 12.9 4.3 17.2 4.3l167.69 167.7c8.6 8.6 8.6 21.5 0 30.09l-60.2 60.2-197.79-197.79 60.2-60.2c-0.01 0 4.29-4.3 12.9-4.3zM211.23 399.23l77.39-77.4c12.9-12.9 12.9-34.4 0-47.3-12.9-12.9-34.4-12.9-47.3 0l-77.39 77.4-55.9-55.9c-8.6-8.6-8.6-21.5 0-30.1l167.7-167.69c4.3-4.3 8.6-4.3 17.2-4.3s12.9 4.3 17.2 4.3l154.8 159.09-197.8 197.79-55.9-55.89z m189.19 442.88s-4.3 4.3-8.6 4.3l-262.29 94.6c-8.6 4.3-17.2 0-21.5-8.6-4.3-4.3-4.3-8.6-4.3-17.2l94.6-262.29c0-4.3 4.3-4.3 4.3-8.6l438.58-438.58L839 403.53l-86 86-257.99 257.98-94.59 94.6z m541.78-77.39L774.5 932.41c-8.6 8.6-21.5 8.6-30.1 0l-55.9-55.89 77.4-77.4c12.9-12.9 12.9-34.4 0-47.3-12.9-12.9-34.4-12.9-47.3 0l-77.4 77.4-55.89-55.9 197.79-197.8 159.1 159.1c8.6 8.6 8.6 21.49 0 30.1z m0 0"
                  :fill="modelSuccess ? '#333333' : '#cccccc'" p-id="8568"></path>
              </svg>
            </el-button>
            <reader-select-model-bar style="display: none" icon="filter_alt" template_type="${this.template_type}"
              slot="bar-btn" :models="modelConf"></reader-select-model-bar>
            <!--            <el-popover
                placement="top"
                trigger="hover">
              <p style="text-align: center;">请联系客户经理开通服务</p>
              <div style="margin: 5px 0px 0px 0px; text-align: center;">
                <el-image
                    style="width: 140px; height:140px"
                    :src="concatImg"
                    :preview-src-list="[concatImg]">
                </el-image>
              </div>

              <el-button  slot="reference" style="top:1px; margin-left:5px;" type="text" @click="gotoDiyPage" title="点击定制" disabled>
                <svg t="1698637270081" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3363" width="24" height="24"><path d="M218.709333 256a170.752 170.752 0 0 1 330.581334 0H917.333333a21.333333 21.333333 0 0 1 21.333334 21.333333v42.666667a21.333333 21.333333 0 0 1-21.333334 21.333333h-368.042666a170.752 170.752 0 0 1-330.581334 0H106.666667a21.333333 21.333333 0 0 1-21.333334-21.333333v-42.666667a21.333333 21.333333 0 0 1 21.333334-21.333333h112.042666zM384 384a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z m421.290667 298.666667H917.333333a21.333333 21.333333 0 0 1 21.333334 21.333333v42.666667a21.333333 21.333333 0 0 1-21.333334 21.333333h-112.042666a170.752 170.752 0 0 1-330.581334 0H106.666667a21.333333 21.333333 0 0 1-21.333334-21.333333v-42.666667a21.333333 21.333333 0 0 1 21.333334-21.333333h368.042666a170.752 170.752 0 0 1 330.581334 0zM640 810.666667a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z" :fill="modelSuccess ? '#333333' : '#cccccc'" p-id="3364"></path></svg>
              </el-button>
            </el-popover>-->
            <el-popover v-if="isPdfFile" placement="top" trigger="hover">
              <p style="text-align: center;">功能优化中，有需求，<br />可以直接反馈家户经理</p>
              <div style="margin: 5px 0px 0px 0px; text-align: center;">
                <el-image style="width: 140px; height:140px" :src="concatImg" :preview-src-list="[concatImg]">
                </el-image>
              </div>

              <el-button slot="reference" style="top:2px; margin-left:5px;  position: relative;" type="text"
                @click="gotoDiyPage" title="导出" disabled>
                <svg t="1695785776591" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="5750" width="18" height="18">
                  <path
                    d="M0 841.142857m66.742857 0l890.514286 0q66.742857 0 66.742857 66.742857l0 49.371429q0 66.742857-66.742857 66.742857l-890.514286 0q-66.742857 0-66.742857-66.742857l0-49.371429q0-66.742857 66.742857-66.742857Z"
                    fill="#cccccc" p-id="5751"></path>
                  <path
                    d="M900.937143 249.234286L600.137143 3.84a16.457143 16.457143 0 0 0-26.88 12.617143v91.428571a16.64 16.64 0 0 1-14.994286 16.274286c-389.485714 38.4-438.857143 358.4-441.234286 509.805714a16.457143 16.457143 0 0 0 31.268572 7.314286c73.142857-150.674286 227.84-230.4 407.771428-237.714286a16.64 16.64 0 0 1 17.188572 16.64v88.137143a16.457143 16.457143 0 0 0 26.88 12.8L900.937143 274.285714a16.64 16.64 0 0 0 0-25.051428z"
                    fill="#cccccc" p-id="5752"></path>
                </svg>
              </el-button>
            </el-popover>
            <reader-bar-export-i v-else style="position: relative; top:5px; transform: scale(0.9); width:25px;"
              slot="bar-btn" styleType="icon" icon="file_download" title="导出" withModel disabled></reader-bar-export-i>
            <reader-bar-file-list style="position: relative; top:3px; width:28px; transform: scale(0.9); "class="bar-option" title="最近文件"
              slot="bar-close" :domain="serverUrl" :satoken="requestHeader.satoken" path="md/temp" styleType="icon"
              icon="history"></reader-bar-file-list>

          </div>
          <el-button type="text" style="margin-right:4px; margin-left:3px; position: relative; top:-1px;"
            icon="el-icon-message" @click="openUserMesssage" title="我的消息" slot="bar-close"></el-button>
          <el-dropdown slot="bar-close"
            @command="handelMenulSelect">
            <span class="el-dropdown-link">
              <i class="el-icon-user-solid"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="showInfo">修改信息</el-dropdown-item>
              <el-dropdown-item command="logout">退出账号</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <reader-navigator slot="navigators">
            <reader-nav-catalog id="reader-catalog" name="目录" placeholder="请输入目录名称..."></reader-nav-catalog>
          </reader-navigator>
          <reader-file-inspector slot="page" :key="zhaiyaokey" label="摘" title="摘要信息查看" :config='zyConf'
            style="color:#00A5BA;border-color:#00A5BA;"></reader-file-inspector>
          <reader-page-html-i slot="page"></reader-page-html-i>
          <reader-data-menu-ctrl slot="page"></reader-data-menu-ctrl>
          <reader-chat slot="page"></reader-chat>
          <reader-sourcing></reader-sourcing>
          <reader-inspector-extreader menuName="解读" withSubject slot="inspector"></reader-inspector-extreader>
          <reader-inspector menuName="校验结果" slot="inspector"></reader-inspector>
          <reader-view-builder></reader-view-builder>
          <reader-inspector-contextselect></reader-inspector-contextselect>
          <wc-msg-dialog></wc-msg-dialog>

        </i-reader>
        <reader-desc-intensive v-if="viewDesc"></reader-desc-intensive>
      </template>
      <!-- 辅助撰文弹窗 -->
      <cmdp-reader-search v-else-if="readerType == 'fuzhuzhuanwen'" orgFullName="中广核核技术发展股份有限公司" orgSecCode="003816"
        :domain="serverUrl" :satoken="requestHeader.satoken"></cmdp-reader-search>
      <!-- 仿写报告弹窗 -->
      <cmdp-workshop-ult v-else-if="readerType == 'fangXieBaoGao'" :domain="serverUrl"
        :satoken="requestHeader.satoken"></cmdp-workshop-ult>
      <!-- 小智写文 -->
      <cmdp-writer v-else-if="readerType == 'xiaozhixiewen'" :domain="serverUrl" hideSettingBtn hideMessageBtn
        :satoken="requestHeader.satoken">
        <div slot="bar-btn" style="width:24px; margin-left:5px;">
          <el-button type="text" icon="el-icon-message" @click="openUserMesssage" title="我的消息"></el-button>
        </div>

        <el-dropdown slot="bar-close" @command="handelMenulSelect">
          <span class="el-dropdown-link">
            <i class="el-icon-user-solid"></i>
          </span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="showInfo">修改信息</el-dropdown-item>
            <el-dropdown-item command="logout">退出账号</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </cmdp-writer>
      <!-- 空 -->
      <el-empty v-else description="未找到对应阅读器"></el-empty>
    </div>
    <div style="height:100vh;width:100%;" v-if="readerType == 'xiaozhixuexi' && xiaozhixuexiDataLonginged">
      <!-- 小智学习 -->
      <cmdp-workshop-ml :domain="serverUrl" :satoken="requestHeader.satoken" :raw.prop="raw"></cmdp-workshop-ml>
    </div>
    <el-dialog top="10vh" title="修改信息" :visible.sync="showInfoDialog" width="60%" :close-on-click-modal='false'
      :fullscreen="false" @close="btnCloseInfoDialog">
      <user-info @saveSuccess="btnCloseInfoDialog" @saveCancel="btnCloseInfoDialog"></user-info>
    </el-dialog>
    <el-dialog custom-class="print-dialog" top="10vh" title="个性化定制" :visible.sync="showPrintDialog" width="1100px"
      :close-on-click-modal='false' :fullscreen="false" @close="btnClosePrintDialog">
      <!-- <iframe v-if="showPrintDialog" id="printIframe" frameborder="0" :src="`${cmdpUrl}/df/index/print?satoken=${requestHeader.satoken}&eid=${selectEid}`" style="width:100%; max-height: calc( 80vh - 60px );"></iframe> -->
      <print v-if="showPrintDialog" :eid=selectEid></print>
    </el-dialog>
  </div>
</template>

<script>
import apiAxios from "@/config/apiAxios";
import userInfo from "../../user/info"
import concatImg from "../../../assets/img/contact_me_qr.png"
import print from "@/components/common/print"
export default {
  name: 'readerPage',
  components: { userInfo, print },
  data() {
    return {
      readerType: '',
      requestHeader: {
        satoken: localStorage.getItem('USER_TOKEN_VAL')
      },
      // serverUrl: 'https://a.cmdp.cn',
      serverUrl: config.serverUrl,
      cmdpUrl: config.cmdpUrl,
      raw: {},
      xiaozhixuexiDataLonginged: false,
      isLoading: false,
      showInfoDialog: false,
      showPrintDialog: false,
      viewDesc: true,
      modelSuccess: false,
      selectModels: {},
      selectEid: "",
      concatImg: concatImg,
      _orgFullName: "宁德时代新能源科技股份有限公司",
      _currentFile: {},

      zyConf: "",
      zhaiyaokey: $func.getUUID_resource(),
      // zyConf: JSON.stringify({
      //   type: "szzk",
      //   headerConfig: false,
      //   bodyConfig: {
      //     gridStackOptions: { margin: 5, column: 12, minRow: 1, cellHeight: 120, disableOneColumnMode: true, float: true, removable: ".trash", itemClass: "with-lines", acceptWidgets: true }, gridStackItem: [{
      //       x: 0, y: 0, w: 6, h: 2, cardtitle: "基本信息", type: "card-markdown", src: "", data: [],
      //       _params: {
      //         filePath: this._currentFile.src, apiCode: "DA000066",
      //         companyName: this._orgFullName
      //       }
      //     },
      //     {
      //       x: 6, y: 0, w: 3, h: 2, cardtitle: "监管信息", type: "card-markdown", src: "", data: [],
      //       _params: {
      //         filePath: this._currentFile.src, apiCode: "DA000101",
      //         companyName: this._orgFullName
      //       }
      //     },
      //     { x: 9, y: 0, w: 3, h: 2, cardtitle: "校验信息", type: "card-vega", src: "", data: [] },
      //     {
      //       x: 0, y: 2, w: 9, h: 2, cardtitle: "重大事件", type: "card-markdown", src: "", data: [],
      //       _params: {
      //         filePath: this._currentFile.src, apiCode: "DA000102",
      //         companyName: this._orgFullName
      //       }
      //     },
      //     {
      //       x: 9, y: 2, w: 3, h: 2, cardtitle: "后续事项", type: "card-markdown", src: "", data: [],
      //       _params: {
      //         filePath: this._currentFile.src, apiCode: "DA000104",
      //         companyName: this._orgFullName
      //       }
      //     },

      //     ]
      //   },
      //   footerConfig: {}
      // }),
      modelConf: JSON.stringify([{
        "id": "07",
        "type": "content",
        "withCatalog": true,
        "initPbc": "DA000044",
        "initPbcType": "cmd",
        "infoPbc": "DA000044",
        "infoPbcType": "cmd",
        "params": {},
        "tags": [],
        "text": "小智智聚",
        "enabled": true
      }]),
      isPdfFile: false
    }
  },

  methods: {
    getXiaozhixuexiData() {
      let _that = this;
      //先写死某个业务要素
      let params = {
        "dir": "usys/ld/release",
        // "fid": "6f7fff20ad5d94884245ea8b45c6b34d"//测试环境
        "fid": "17559f248befaeb7f1db58b4cfa8a100"//测试环境
      }
      if (config.active == "prod") {
        params.fid = "5bbed962e6f3d9f8e5026bf7324fe0f2"//生产环境
      }
      _that.isLoading = true;
      apiAxios.apmSyncPost('api000164', params, {}, _res => {
        if (_res.code == 200 && _res.data) {
          _that.raw = _res.data;
          if (_that.raw?.ld?.uri) {
            _that.raw.ld = _that.raw.ld.uri;
          }
          _that.xiaozhixuexiDataLonginged = true;
        } else {
          this.$message({
            type: 'error',
            message: '获取数据失败'
          })
        }
        _that.isLoading = false;
      });
    },

    openUserMesssage() {
      this.$EventBus.$emit('opendialogTaskCenter')
    },

    gotoDiyPage() {
      this.showPrintDialog = true;
      // window.open('https://www.cmdp.cn/df/index/print ');
    },
    handelMenulSelect(command) {
      if (command == 'logout')
        this.logout();
      else
        this.showInfo();
    },
    showInfo() {
      this.showInfoDialog = true;
    },
    btnCloseInfoDialog() {
      this.showInfoDialog = false;
    },
    btnClosePrintDialog() {
      this.showPrintDialog = false;
    },
    logout() {
      localStorage.removeItem('USER_ISLOGIN');
      localStorage.removeItem('USER_TOKEN_TAG');
      localStorage.removeItem('USER_TOKEN_VAL');

      sessionStorage.clear();
      location.reload();
    },
    /**摘要参数处理 */
    getzhaiyaoConfig() {
      this.zyConf = JSON.stringify(
        {
          type: "szzk",
          headerConfig: false,
          bodyConfig: {
            gridStackOptions: {
              margin: 5, column: 12, minRow: 1,
              cellHeight: 120, disableOneColumnMode: true,
              float: true, removable: ".trash", itemClass: "with-lines",
              acceptWidgets: true, disableDrag: true, disableResize: true
            },
            gridStackItem: [{
              x: 0, y: 0, w: 3, h: 2, cardtitle: "基本信息", type: "card-markdown", src: "", data: [],
              _params: {
                filePath: this._currentFile.src, apiCode: "DA000066",
                companyName: this._orgFullName
              }
            },
            {
              x: 3, y: 0, w:6, h: 2, cardtitle: "监管信息", type: "card-markdown", src: "", data: [],
              _params: {
                filePath: this._currentFile.src, apiCode: "DA000101",
                companyName: this._orgFullName
              }
            },
            { x: 9, y: 0, w: 3, h: 2, cardtitle: "校验信息", type: "card-vega", src: "", data: [] },
            {
              x: 0, y: 2, w: 9, h: 2, cardtitle: "重大事件", type: "card-markdown", src: "", data: [],
              _params: {
                filePath: this._currentFile.src, apiCode: "DA000102",
                companyName: this._orgFullName
              }
            },
            {
              x: 9, y: 2, w: 3, h: 2, cardtitle: "后续事项", type: "card-markdown", src: "", data: [],
              _params: {
                filePath: this._currentFile.src, apiCode: "DA000104",
                companyName: this._orgFullName
              }
            },

            ]
          },
          footerConfig: {}

        });
      this.zhaiyaokey = $func.getUUID_resource();
    }
  },

  // watch:{
  //   _orgFullName(newValue){
  //     this.getzhaiyaoConfig()
  //   },
  //   "_currentFile.src":{
  //     handler(value){
  //       this.getzhaiyaoConfig()
  //     },
  //     deep:true
  //   }

  // },

  created() {
    if (localStorage.getItem("USER_ISLOGIN") != 'true') {
      this.$message({
        type: 'warning',
        message: '未找到您的登录信息'
      })
      this.$router.push({ name: 'index' })
      return;
    }
    sessionStorage.setItem("USER_TOKEN_VAL", localStorage.getItem('USER_TOKEN_VAL'));

    this.readerType = this.$route.meta.type || this.$route.query.readerType;
    if (!['xiaozhijiedu', 'fuzhuzhuanwen', 'fangXieBaoGao', 'xiaozhixiewen', 'xiaozhixuexi'].includes(this.readerType)) {
      this.$message({
        type: 'warning',
        message: '未找到对应阅读器'
      })
      console.log('11111')
      this.$router.push({ name: 'index' })
    }

    if (this.readerType == 'xiaozhixuexi') {
      this.getXiaozhixuexiData();
    }

    window.addEventListener(
      "message",
      (event) => {
        if (event.data.key == 'reader.setProp.currentFile') {
          this.isPdfFile = event.data.value?.fileInfo?.extension?.toLowerCase() == '.pdf';
          this._currentFile = event.data.value;

          this.viewDesc = false;
          this.getzhaiyaoConfig();
        }
        if (event.data.key == 'reader.setProp.model.process.success') {
          this.modelSuccess = true;
        }
        if (event.data.key == 'reader.setProp.selectModels') {
          this.selectModels = event.data.value;
        }

        if (event.data.key == 'reader.setProp._org_eid') {
          this.selectEid = event.data.value;
        }
        if (event.data.key == 'reader.setProp._org_full_name') {
          this._orgFullName = event.data.value;
          this.getzhaiyaoConfig();
        }
        if (event.data.key == 'print.loading.success') {
          let iframe = document.getElementById('printIframe');
          if (iframe) iframe.contentWindow.postMessage({ key: 'select.model.datas', value: this.selectModels }, "*");
        }
      },
      false,
    );

  },

  mounted() {

  }
}
</script>

<style scoped lang="less">
.el-button {
  color: rgba(0, 0, 0, 0.9);

  /deep/ i {
    color: rgba(0, 0, 0, 0.7);
    font-size: 17px;
  }
  /deep/ svg{
    width:15px; height:15px;
  }
}

cmdp-workshop-intensive {
  .el-button {
    &.el-button--text {
      padding: 6px;
      margin: 0px;

      &:hover {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }
  .el-dropdown{
    i{
      font-size: 17px;
    }
  }
}

/deep/ .print-dialog {
  border-radius: 10px;

  .el-dialog__header {
    height: 60px;
    line-height: 60px;
    padding: 0 20px;
  }

  .el-dialog__title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #303133;
  }

  .el-dialog__headerbtn {
    height: 60px;
    line-height: 60px;
    top: 0;
    right: 20px;
  }

  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>
